import { ImageMime } from './utils/imageTypes';

export const LOGGER_NAME = 'studio-templates';

export const IMAGES_DOMAIN = 'images-wixmp-530a50041672c69d335ba4cf.wixmp.com';

export const DEFAULT_IMAGE_FILTER = 'q_90,usm_0.60_1.00_0.01';

export const DEFAULT_IMAGE_TYPES: ImageMime[] = [
  ImageMime.WEBP,
  ImageMime.JPEG,
];

export const SOURCE_IMAGE_SIZES = {
  preview: {
    width: 3840,
    height: 2160,
  },
  '16x9': {
    width: 1920,
    height: 1080,
  },
};

export const BREAKPOINTS_CONFIG = [
  {
    maxScreenWidth: 768,
    imageWidth: 322,
    densityList: [1, 2],
  },
  {
    maxScreenWidth: 1024,
    imageWidth: 450,
    densityList: [1, 2],
  },
  {
    maxScreenWidth: 1280,
    imageWidth: 538,
    densityList: [1, 2],
  },
  {
    maxScreenWidth: 1365,
    imageWidth: 393.656,
    densityList: [1, 2],
  },
  {
    maxScreenWidth: 1366,
    imageWidth: 367.33,
    densityList: [1, 2],
  },
  {
    maxScreenWidth: 1680,
    imageWidth: 472,
    densityList: [1, 2],
  },
  {
    maxScreenWidth: 1920,
    imageWidth: 536,
    densityList: [1, 2], // 1x, 2x
  },
  {
    maxScreenWidth: 2560,
    imageWidth: 749.33,
    densityList: [1, 2], // 1x
  },
];
